import { EyeIcon, EyeSlashIcon } from '@phosphor-icons/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'

import { PASSWORD_MASK } from '../../../../shared/form-changes'
import * as S from './provider-card.styled'

interface SecretValueProps {
  value: string
}

export const SecretValue = ({ value }: SecretValueProps) => {
  const { t } = useTranslation(['common'])
  const [isVisible, setIsVisible] = useState(false)

  return (
    <>
      <S.SecretText>{isVisible ? value : PASSWORD_MASK}</S.SecretText>
      <Button
        onlyBox
        size="small"
        use="ghost"
        title={isVisible ? t('common:actions.hidePassword') : t('common:actions.showPassword')}
        onClick={() => setIsVisible((visible) => !visible)}
      >
        <Icon icon={isVisible ? EyeSlashIcon : EyeIcon} />
      </Button>
    </>
  )
}
